<template>
  <div
    class="board"
    ref="board"
  >
    <div class="sks"><span @click="gos">
        ＜ </span>
      龙骨整件购
    </div>
    <div class="fu">
    <div class="" id="main"></div>
    <div class="dang"></div>
    <div class="di"></div>
    </div>
  
  <div class="t1">
    <img src="../../assets/lg/02.png" alt="">
  </div>
    <div class="flp">
      <div class="fenl clearfix">
        
        <div
          class="fenl_1"
          @click="toList(v.id)"
          v-for="v in list"
          :key='v.id'
        >
          <img :src="v.thumb" />
          <!-- <div>{{ item }}</div> -->
          <div class="ellipsis-multiline">{{v.name}}</div>
        </div>
      </div>
    </div>
      <van-swipe :autoplay="3000">
      <van-swipe-item
       
      >
        <img
          src="../../assets/lg/03.png"
          alt=""
        >
      </van-swipe-item>
 <van-swipe-item
       
      >
        <img
          src="../../assets/lg/06.jpg"
          alt=""
        >
      </van-swipe-item> <van-swipe-item
       
      >
        <img
          src="../../assets/lg/07.jpg"
          alt=""
        >
      </van-swipe-item>
    </van-swipe>
    <div>
     
      <div class="cp1">
        <div class="top clearfix">
          <div
            class="one"
            @click="toList(v.id)"
            v-for="v in list"
            :key='v.id'
          >
            <img
              :src="v.thumb"
              alt=""
            />
            <div class="name">
              <p>货空间</p>
              <p>{{v.name}}</p>
            </div>
            <div class="price">
              <span>￥{{v.min_price}}</span>  <b>热卖价</b> 
            </div>
          </div>
         
        </div>
      </div>
    </div>

    <img
      class="ak1"
      src="../../assets/lg/03.jpg"
      alt=""
    />
   <img
      class="ak1"
      src="../../assets/lg/04.jpg"
      alt=""
    />
    <img
      class="ak1"
      src="../../assets/lg/05.jpg"
      alt=""
    />
    <!-- <div class="wgdb jia">
      <img
        class="wen1"
        src="../../assets/sks/sksw3.png"
        alt=""
      />
    </div> -->
    <!-- <div class="xgd"></div> -->

 
   
   
  </div>
</template>
<script>
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast } from 'vant'

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true })
  .use(NoticeBar)
  .use(Grid)
  .use(GridItem).use(Popup).use(Button)

export default {
  name: 'board',
  data () {
    return {
      value: '',
      show: false,
      images: [1, 2],
      searchBarFixed: false,
      navSwitch: 1,
      number: -1,
      str: '',
      ad: [],
      classList: [],
      classList1: [],
      screenType: 'zonghe',
      productList: [],
      isEnd1: true,
      deswiper: '',
      login: sessionStorage.getItem('login'),
      isEnd: false, //判断是否为最后一页
      params: {
        page: 1,
        id: '',
        sort_field: 'sort',
        class_three: '',
        sort_type: '',
      },
      screenState: 1,
      totalHeight: 0,
      statusNav: 1,
      id: 157,
      fg:0,
      list:[],
      xlist:[],
      ylist:[]
    }
  },
  props: {
  },
  computed: {

  },
  watch: {

  },
  created () {
   
    // this.ec()
    this.axios.get('listGoodsByCateBrand', { params: { store_id:this.$store.state.shopid, class_id: this.$route.query.id, class_name:'货空间实时龙骨'} }).then(res => {
          res.data.data.forEach(v=> {
          v.name= v.name.slice(3)
           
          })
          this.list=res.data.data
        }).catch(ref => { })
        
        this.axios.post('getSteelPrice').then(res => {
          res.data.data.forEach((v,i)=>{
            if(i<7){
            this.xlist.push(v.vdate)
            this.ylist.push(v.steel_price)
            }
         
          })
          var myChart = this.$echarts.init(document.getElementById('main'))
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: ''
        },
       tooltip: {},
        legend: {
          data: ['']
        },
        xAxis: {
           type: 'category',
          data: this.xlist.reverse()
        },
        yAxis: {
    

           type: 'value',
           min: function (value) {
    // return value.min = 4000;
}
        },
        series: [
          {
            type: 'line',
            smooth: true,
            data: this.ylist.reverse()
          }
        ]
      }
      // option.yAxis.show=false
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)

         
        }).catch(ref => { })
  },
  mounted () {
 
  },
  methods: {
    gos () {
      this.$router.go(-1)
    },
   
    go (i) {
      // Toast('正在努力备货中~')

      // return false
      if (i == 1) {
        this.$router.push({
          name: 'product',
          query: {
            id: 2112
          }
        })
      } else if (i == 2) {
        this.$router.push({
          name: 'product',
          query: {
            id: 2112        }
        })
      } else if (i == 3) {
        this.$router.push({
          name: 'product',
          query: {
            id: 2113
          }
        })
      } else if (i == 4) {
        this.$router.push({
          name: 'product',
          query: {
            id: 2110
          }
        })
      }
    },
    getClientHeight () {

    },


    enterDetail (goods) {
      return false
      this.$router.push({
        name: 'product',
        params: {
          id: goods.id,
          status: 1,
        },
      })
    },
    toList (id) {
      // return false
     
      this.$router.push({
        name: 'product',
        params: {
          status: 1,
        },
        query: {
          id
        }
      })
    },

    active (i) {
      this.params.class_three = i
      this.navSwitch = 1
      this.productList = []
      this.params.page = 1
      this.isEnd = false
      this.getProductList()
    },
    getProductList () {

    },
    getClassList () {

    },
  },

  destroyed () { },
  updated () { },
  components: {},
}
</script>


<style lang="less" scoped>
.fu{
  position: relative;
  width: 100%;
  height: 6rem;
  background: url('../../assets/lg/bj.jpg') no-repeat center ;
  background-size:100%;
  .dang{
    width: 100%;
    height: 5rem;
    position: absolute;
    top: 10%;
    left: 0;
    z-index: 99;
  }
  .di{
    width: 98%;
    height: 3.5rem;
    position: absolute;
    background-color: #fff;
    top: 28%;
    left: 1%;
    z-index:66;
  }
}
#main{
  padding-left: 0.2rem;
  position: absolute;
 left: 0;
  top: 8%;
  width: 110%;
  height: 6rem;
  z-index: 88;
  // background-color: #fff;
}
.t1{
  padding: 0 0.2rem;
}
.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.sks {
  width: 100%;
  z-index: 99;
  height: 1rem;
  background-color: #fff;
  text-align: center;
  font-size: 0.4rem;
  line-height: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 1rem;
    position: absolute;
    left: 0;
    font-size: 0.5rem;
  }
}
.sp {
  width: 100%;
  height: 5.4rem;
  overflow: hidden;
}
.sp::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.pad {
  height: 0.15rem;
  border-top: 0.1rem solid #dbdbdb;
  background-color: #fff;
}
.more {
  color: #c9a48a;
  font-size: 0.7rem;
  text-align: center;
  height: 1.5rem;
  line-height: 1.5rem;
}
.fl2p {
  background-color: #f5f5f5;
  padding: 0 0.2rem;
}
.wgd {
  padding: 0 0.2rem;
  text-align: center;
  position: relative;
  height: 0.5rem;
  .qx {
    position: absolute;
    left: 0;
    width: 100%;
    top: 0.5rem;
    z-index: 20;
  }
  .gd {
    height: 0.5rem;
  }
}
.red{
  height: 0.4rem;
  background-color: red;
}
.wgdb {
  background-color: #f3f3f3;
  text-align: center;
  // padding-top: 0.7rem;
  
}
.cp1 {
  background-color: #f3f3f3;
  padding: 0.2rem;
  .top {
    background-color: #f3f3f3;

    .one {
      width: 46%;
      padding:0.2rem ;
      float: left;
      margin: 2%;
      background-color: #fff;
      border-radius: 0.45rem;
      img {
        // width: 100%;
        background-color: #fff;
        height: 4.5rem;
        border-radius: 0.25rem;
      }
      .name{
        padding-top: 0.2rem;
        p{
          padding-left: 0.2rem;
        font-size: 0.35rem;
        line-height: 0.5rem;
        font-weight: 600;

        }
      }
      .price{
       margin-top: 0.2rem;
        margin-left: 0.2rem;
        background-color: #111111;
        color: #fff;
        width: 80%;
        line-height: 0.49rem;
        font-weight: 600;
        border-radius: 0.25rem;
          border: #111111 solid 0.01rem;
          border-bottom: #111111 solid 0rem;
          // padding-left: 0.6rem;
        span{
          padding:0  0.2rem ;
          color: #f53c3c;
          background-color: #fff;
          // border-top: #111111 solid 0.01rem;
        border-radius: 0.2rem;
        line-height: 0.35rem;
        font-size: 0.35rem;

        }
        b{
         font-size: 0.35rem;
        // line-height: 0.6rem;

        }
      }
    }
  }
}
.ak1 {
  padding: 0.2rem;
  background-color: #fff;
  width: 100%;
}
.jia {
 
}
.xgd {
  height: 0.5rem;
  background-image: linear-gradient(#f3f3f3, #fff);
}
.comm-null {
  padding-top: 0.5rem;

  p {
    font-size: 0.28rem;
    color: #666;
    padding-top: 0.2rem;
  }
}
.swiper-container {
  width: 100%;
  height: 3.28rem;
  .home-banner-img {
    width: 100%;
  }
}
.board_content {
  background: white;
  padding: 0 0.23rem;
  margin-top: 1px;
  padding-bottom: 0.15rem;

  .board_content1 {
    padding-top: 0.2rem;

    div:first-child {
      color: #333;
      font-size: 0.22rem;
      margin-bottom: 0.15rem;
    }

    .board_c {
      //    border:1px solid red;
      div {
        float: left;
        color: #333;
        font-size: 0.22rem;
        border: 1px solid #e5e5e5;
        width: 21.5%;
        margin: 0.1rem 0;
        border-radius: 0.05rem;
        text-align: center;
        height: 0.47rem;
        line-height: 0.47rem;
        margin-left: 2.55%;
      }
    }
  }
}

.isActive {
  color: #a22d2b !important;
  border: 1px solid #a22d2b !important;
}

.board {
  padding-top: 1rem;
  // 轮播
  overflow-x: hidden;
  //   padding-top: 0.8rem;
  background-color: #f3f3f3;
  .mint-swipe {
    width: 100%;
    height: 3.28rem;

    .mint-swipe-items-wrap {
      width: 100%;
      height: 3.28rem;

      .mint-swipe-item {
        width: 100%;
        height: 3.28rem;

        .board-banner-img {
          width: 100%;
          height: 3.28rem;
          background-size: 100%;
        }
      }
    }
  }
  .flp {
    background-color: #f3f3f3;
    padding: 0 0.2rem;
    padding-top: 0.2rem;
  }
  .fenl {
    p {
      height: 0.75rem;
      line-height: 0.5rem;
      font-weight: 700;
      font-size: 0.3rem;
    }
    background: #f3f3f3;
    padding: 0 0.3rem;
    padding-top: 0.15rem;
    text-align: center;
    box-sizing: border-box;

    .fenl_1 {
      width: 33%;
      text-align: center;
      float: left;
      margin-bottom: 0.45rem;

      img {
        width: 1.9rem;
        height: 1.9rem;
        border-radius: 5px;
        margin: 0 auto;
      }

      div {
        color: #333;
        font-size: 0.34rem;
        margin-top: 0.22rem;
      }
    }
  }

  .mt {
    margin-top: 10px;
  }

  .scrolltop {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1000;
    margin-top: 0;
  }

  .board_imglist {
    background: #fff;
    margin-top: 1px;
    padding: 0.21rem;
    padding-top: 0.26rem;
    padding-bottom: 0.45rem;

    .board_img:nth-child(odd) {
      float: left;
      width: 48.5%;
    }

    .board_img:nth-child(even) {
      float: right;
      width: 48.5%;
    }

    .board_img {
      height: 5rem;

      .title {
        height: 0.6rem;
      }

      div:first-child {
        img {
          width: 100%;
          height: 3.2rem;
        }
      }

      div:nth-child(2) {
        margin-top: 0.16rem;

        span.sp1 {
          color: #a22d2b;
          font-size: 0.26rem;
          border: 1px solid #a22d2b;
          padding: 0.02rem 0.05rem;
          border-radius: 0.05rem;
        }

        span.sp2 {
          color: #333;
          font-size: 0.26rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          width: 100%;
        }
      }

      div:last-child {
        margin-top: 0.16rem;

        span:first-child {
          color: #a22d2b;
          font-size: 0.26rem;
        }

        /*span:last-child {*/
        /*line-height: 0.2rem;*/
        /*color: #999;*/
        /*font-size: .26rem;*/
        /*text-decoration: line-through*/
        /*}*/
      }
    }
  }
}
.ellipsis-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
